import { render, staticRenderFns } from "./PacienteFormulario.vue?vue&type=template&id=4eed7e13&scoped=true"
import script from "./PacienteFormulario.vue?vue&type=script&lang=js"
export * from "./PacienteFormulario.vue?vue&type=script&lang=js"
import style0 from "./PacienteFormulario.vue?vue&type=style&index=0&id=4eed7e13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eed7e13",
  null
  
)

export default component.exports